import React from "react";
import { SubSection } from "context/BlogContext";

interface PreviewVideoProps {
  subSection: SubSection;
}

const PreviewVideo: React.FC<PreviewVideoProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "video" && (
        <div className="">
          <div className="pt-5 h-[250px] flex justify-center w-auto flex justify-center">
            <iframe
              className="rounded-md h-full w-auto aspect-video"
              title="Embedded YouTube Video"
              src={subSection.attrs.src}
            ></iframe>
          </div>
          {/* <p className="pt-4">{subSection.attrs.caption}</p> */}
        </div>
      )}
    </div>
  );
};

export default PreviewVideo;
